// biome-ignore lint/suspicious/noExplicitAny: Must be generic.
export function assert<T = any>(condition: T, errorMessage: string): asserts condition {
  if (!condition) {
    throw new Error(errorMessage)
  }
}
